import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'wlm-error-window',
    templateUrl: './error-window.component.html',
    styleUrls: ['./error-window.component.scss'],
    standalone: false
})
export class ErrorWindowComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public error: Error) {}
}
